import { Routes } from "@angular/router";

import { PagesComponent } from "./views/pages/pages.component";

import { LoginComponent } from "./views/pages/base/security/login/login.component";
import { ForgotPasswordComponent } from "./views/pages/base/security/login/forgot-password.component";
import { ResetPasswordComponent } from "./views/pages/base/security/login/reset-password.component";

import { OrderEntryComponent } from "./views/pages/transaction/op/outbound/order/order-entry/order-entry.component";
// import { NewOrderComponent } from './pages/order/order-entry/new-order/new-order.component';
import { OrderListComponent } from "./views/pages/transaction/op/outbound/order/order-list/order-list.component";
import { InventoryBalanceReportComponent } from "./views/pages/transaction/reports/inventory-balance-report/inventory-balance-report.component";
import { InventoryBalanceAvailableReportComponent } from "./views/pages/transaction/reports/inventory-balance-available-report/inventory-balance-available-report.component";
import { InventoryBalanceByAsnReportComponent } from "./views/pages/transaction/reports/inventory-balance-by-asn/inventory-balance-by-asn-report.component";
import { InventoryBalanceByProductReportComponent } from "./views/pages/transaction/reports/inventory-balance-by-product/inventory-balance-by-product-report.component";
import { InventoryBalanceByWarehouseReportComponent } from "./views/pages/transaction/reports/inventory-balance-by-warehouse/inventory-balance-by-warehouse-report.component";

import { UserManagerComponent } from "./views/pages/base/security/user-manager/user-manager.component";

import { ChangePasswordComponent } from "./views/pages/base/security/change-password/change-password.component";
import { UserProductConfigComponent } from "./views/pages/master/op/user-product-config/user-product-config.component";

import { InvoiceReportComponent } from "./views/pages/transaction/reports/invoice-report/invoice-report.component";
import { LoadingBookingComponent } from "./views/pages/transaction/op/outbound/booking/loading-booking/loading-booking.component";
import { CreateBookingComponent } from "./views/pages/transaction/op/outbound/booking/create-booking/create.component";
// import { AnnouncementComponent } from './pages/announcement/announcement/announcement.component';
// import { AnnouncementListComponent } from './pages/announcement/announcement-list/announcement-list.component';
import { UserGroupComponent } from "./views/pages/base/security/user-group/user-group.component";
import { UserComponent } from "./views/pages/base/security/user/user.component";

import { TicketEntryComponent } from "./views/pages/transaction/op/outbound/ticket/ticket-entry/ticket-entry.component";
import { TicketTrackingComponent } from "./views/pages/transaction/op/outbound/ticket/ticket-tracking/ticket-tracking.component";
import { TicketConfirmationComponent } from "./views/pages/transaction/op/outbound/ticket/ticket-confirmation/ticket-confirmation.component";

import { ErrorComponent } from "./views/pages/base/config/error/error.component";
import { AboutComponent } from "./views/pages/base/config/about/about.component";

// Announcement
import { AnnouncementListComponent } from "./views/pages/master/op/announcement/announcement-list/announcement-list.component";
import { AnnouncementDetailsComponent } from "./views/pages/master/op/announcement/announcement-details/announcement-details.component";
import { AnnouncementComponent } from "./views/pages/master/op/announcement/announcement/announcement.component";

// Inbound
import { SubmitAsnComponent } from "./views/pages/transaction/op/inbound/asn/submit-asn/submit-asn.component";
import { AsnListComponent } from "./views/pages/transaction/op/inbound/asn/asn-list/asn-list.component";
import { UploadTemplateComponent } from "./views/pages/transaction/interface/upload-template/upload-template.component";
import { AuthGuard } from "./infrastructure/services/base/security/auth-guard";
import { InventoryProductComponent } from "./views/pages/transaction/reports/inventory-product/inventory-product.component";
import { InventoryBalanceLWINReportComponent } from "./views/pages/transaction/reports/inventory-balance-lwin-report/inventory-balance-lwin-report.component";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  {
    path: "pages",
    component: PagesComponent,
    data: { breadcrumb: "Pages" },
    children: [
      { path: "", redirectTo: "announcement", pathMatch: "full" },
      {
        path: "announcement",
        data: { breadcrumb: "Announcement" },
        component: AnnouncementComponent,
      },
      {
        path: "submit-asn",
        data: { breadcrumb: "Submit Asn" },
        component: SubmitAsnComponent,
      },
      { path: "asn-list", data: { breadcrumb: "Asn List" }, component: AsnListComponent },

      {
        path: "create-order",
        data: { breadcrumb: "Create Order" },
        loadChildren:
          "app/views/pages/transaction/op/outbound/order/order-entry/order-entry.module#OrderEntryModule",
      },
      {
        path: "order-list",
        data: { breadcrumb: "Order List" },
        loadChildren:
          "app/views/pages/transaction/op/outbound/order/order-list/order-list.module#OrderListModule",
      },
      {
        path: "inventory-balance-report",
        data: { breadcrumb: "Inventory Balance Report" },
        loadChildren:
          "app/views/pages/transaction/reports/inventory-balance-report/inventory-balance-report.module#InventoryBalanceReportModule",
      },
      {
        path: "inventory-movement-detail-report",
        data: { breadcrumb: "Inventory Movement Detail Report" },
        loadChildren:
          "app/views/pages/transaction/reports/inventory-movement-detail-report/inventory-movement-detail-report.module#InventoryMovementDetailReportModule",
      },
      {
        path: "upload-interface",
        data: { breadcrumb: "Upload Interface" },
        loadChildren:
          "app/views/pages/transaction/interface/upload-template/upload-template.module#UploadTemplateModule",
      },
      {
        path: "user-product-config",
        data: { breadcrumb: "User Product Config" },
        loadChildren:
          "app/views/pages/master/op/user-product-config/user-product-config.module#UserProductConfigModule",
      },

      {
        path: "inventory-balance-available-report",
        data: { breadcrumb: "1nventory Balance Available Report" },
        component: InventoryBalanceAvailableReportComponent,
      },
      {
        path: "inventory-balance-by-asn-report",
        data: { breadcrumb: "1nventory Balance by Asn Report" },
        component: InventoryBalanceByAsnReportComponent,
      },
      {
        path: "inventory-balance-by-product-report",
        data: { breadcrumb: "1nventory Balance by Product Report" },
        component: InventoryBalanceByProductReportComponent,
      },
      {
        path: "inventory-balance-by-warehouse-report",
        data: { breadcrumb: "1nventory Balance by Warehouse Report" },
        component: InventoryBalanceByWarehouseReportComponent,
      },
      {
        path: "inventory-product",
        data: { breadcrumb: "Inventory Enquiry" },
        component: InventoryProductComponent,
      },
      {
        path: "inventory-balance-lwin-report",
        data: { breadcrumb: "LWIN Inventory Balance Report" },
        component: InventoryBalanceLWINReportComponent,
      },

      { path: "user-manager",
        data: { breadcrumb: "User Manager" }, component: UserManagerComponent },
      { path: "change-password",
        data: { breadcrumb: "Change Password" }, component: ChangePasswordComponent },
      { path: "user-group",
        data: { breadcrumb: "User Group" }, component: UserGroupComponent },
      { path: "user",
        data: { breadcrumb: "User" }, component: UserComponent },

      { path: "ticket-entry",
        data: { breadcrumb: "Ticket Entry" }, component: TicketEntryComponent },
      { path: "ticket-tracking",
        data: { breadcrumb: "Ticket Tracking" }, component: TicketTrackingComponent },
      { path: "ticket-confirmation", component: TicketConfirmationComponent },

      { path: "announcement-viewer",
        data: { breadcrumb: "Announcement Viewer" }, component: AnnouncementComponent },
      { path: "announcement-list",
        data: { breadcrumb: "Announcement List" }, component: AnnouncementListComponent },
      { path: "new-announcement",
        data: { breadcrumb: "New Annpuncement" }, component: AnnouncementDetailsComponent },
      { path: "edit-announcement",
        data: { breadcrumb: "edit Announcement" }, component: AnnouncementDetailsComponent },

      { path: "about",
        data: { breadcrumb: "About" }, component: AboutComponent },

      { path: "**", component: ErrorComponent },
    ],
    canActivate: [AuthGuard]
  },
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "**", redirectTo: "pages/404", pathMatch: "full" },
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts